import { render, staticRenderFns } from "./_base-read-more.vue?vue&type=template&id=1f9a6966&"
import script from "./_base-read-more.vue?vue&type=script&lang=js&"
export * from "./_base-read-more.vue?vue&type=script&lang=js&"
import style0 from "./_base-read-more.vue?vue&type=style&index=0&id=1f9a6966&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports